/**
 * AuthContext — extracted from App.js to break the circular import:
 *
 *   Before:  App.js → AdminMode.jsx → App.js  (cycle, works at runtime via
 *            module-export hoisting but flagged by linters and risks edge-
 *            case bundler failures).
 *
 *   After:   App.js  →  AuthContext.js
 *            AdminMode.jsx → AuthContext.js
 *
 * The 36 other consumers (pages/components) continue to do
 *   import { useAuth } from "../App"
 * because App.js re-exports `useAuth` and `AuthContext` from this file.
 */
import { createContext, useContext } from "react";

export const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
};
